import type { LucideIcon } from "lucide-react";
// Re-exported rather than defined here: the Watch page needs the same answer
// and cannot import from v2, so the set lives in @/utils. Existing callers of
// isAdminRole keep importing it from this module.
export { isAdminRole } from "@/utils/userRole";

export type NavItem = {
  key: string;
  label: string;
  icon: LucideIcon;
  route: string;
  /** Hidden until the viewer is logged in. */
  requiresAuth?: boolean;
  /** Hidden unless the viewer is a logged-in admin. */
  adminOnly?: boolean;
};

export type NavViewer = {
  isAuthenticated: boolean;
  isAdmin: boolean;
};

/**
 * The single place nav visibility is decided. Nav components render the
 * result and never re-check auth themselves.
 */
export function filterNavItems(
  items: readonly NavItem[],
  viewer: NavViewer
): NavItem[] {
  return items.filter((item) => {
    if (item.adminOnly) return viewer.isAuthenticated && viewer.isAdmin;
    if (item.requiresAuth) return viewer.isAuthenticated;
    return true;
  });
}
